<div class="bg-e-white">
  <div class="container-default flex flex-col items-center justify-center min-h-[50vh]">
    <h1>{{'logout.logged-out'| translate}}</h1>
    <p>{{'logout.message' |translate}}</p>
  </div>  
</div>
<app-footer></app-footer>

